<template>
  <div
    class="v3-popup virtual-award-detail-popup"
    v-show="virtualAwardDetailPopupState"
  >
    <div class="v3-popup-mask" @click="handleCloseVirtualAwardDetail"></div>
    <div class="v3-popup-content">
      <div
        class="v3-popup-content-close"
        @click="handleCloseVirtualAwardDetail"
      ></div>
      <div class="v3-popup-content-title"></div>
      <div class="v3-popup-content-content">
        <div class="content-bbox">
          <div class="virtual-award-detail-code">
            禮包碼：{{ virtualAwardDetailCode }}
          </div>
          <div class="copy-code-btn btns" @click="copyCode">
            {{ hasCopied ? "已複製" : "複製" }}
          </div>
        </div>
        <div class="tips">請至游戲内使用已領取的禮包碼</div>
      </div>
      <div class="confirm-btn btns" @click="handleCloseVirtualAwardDetail">確認</div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import {
  virtualAwardDetailCode,
  virtualAwardDetailPopupState,
} from "@/hooks/useGetAward";

import useClipboard from "vue-clipboard3";

const { toClipboard } = useClipboard();
const hasCopied = ref(false);

const copyCode = async () => {
  await toClipboard(virtualAwardDetailCode.value);
  hasCopied.value = true;
  setTimeout(() => {
    hasCopied.value = false;
  }, 1000);
};

const handleCloseVirtualAwardDetail = () => {
  virtualAwardDetailPopupState.value = false;
  virtualAwardDetailCode.value = "";
};
</script>
